import {
  IUploadCampaignImagePayload,
  ICampaignImage,
  ICampaign,
  IGetCampaignsFilters,
  ICampaignPayload,
  TNetworkMerchantResult,
} from './types';

import api from '../api/slice';
import { generateCampaignStatus } from './utils';
const campaignsApi = api.injectEndpoints({
  endpoints: builder => ({
    getCampaigns: builder.query<ICampaign[], IGetCampaignsFilters>({
      query: ({ applicationIDs, merchantID, minStartDate, maxEndDate, sortBy, sortOrder }) => {
        const applicationIDsQuery = applicationIDs.map((id: string) => `applicationID=${id}`);
        const params = { minStartDate, maxEndDate, sortBy, sortOrder };
        return {
          method: 'GET',
          url: `/conquest-campaign?${applicationIDsQuery.join('&')}${merchantID ? `&merchantID=${merchantID}` : ''}`,
          params: params,
        };
      },
      transformResponse: (response: ICampaign[]) => {
        return response.map(campaign => generateCampaignStatus(campaign));
      },
      providesTags: ['campaigns'],
    }),
    getInsertionOrder: builder.query<TNetworkMerchantResult, { id: number }>({
      query: ({ id }) => ({
        url: `/conquest-campaign/insertion-order?id=${id}`,
        method: 'GET',
      }),
    }),
    createCampaign: builder.mutation<{ id: number }, ICampaignPayload>({
      query: body => ({
        url: '/conquest-campaign',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['campaigns'],
    }),
    updateCampaign: builder.mutation<any, { id: string; payload: ICampaignPayload }>({
      query: ({ id, payload }) => ({
        url: `/conquest-campaign/${id}`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['campaigns'],
    }),
    uploadCampaignImage: builder.mutation<ICampaignImage, IUploadCampaignImagePayload>({
      query: ({ image }) => {
        const formData = new FormData();
        formData.append('image', image);

        return {
          url: '/conquest-campaign/image',
          method: 'POST',
          body: formData,
          formData: true,
        };
      },
    }),
  }),
});

export const {
  useGetCampaignsQuery,
  useGetInsertionOrderQuery,
  useCreateCampaignMutation,
  useUploadCampaignImageMutation,
  useUpdateCampaignMutation,
} = campaignsApi;

export default campaignsApi;
